import { UserRoleCodes } from '@/types'

import { checkRights } from '@/helpers'

export default [
  {
    path: 'brands/list',
    name: 'manager-brands-list',
    component: () =>
      import('../../../views/Manager/Brands/ManagerBrandList.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'brands/:id',
    name: 'manager-brands-item-general',
    component: () =>
      import('../../../views/Manager/Brands/ManagerBrandItemGeneral.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'brands/:id/seo',
    name: 'manager-brands-item-seo',
    component: () =>
      import('../../../views/Manager/Brands/ManagerBrandItemSeo.vue'),
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
]
